import measures from './measures';
import cities from './cities';

export default {
  modules: {
    measures,
    cities,
  },
};
